"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.encode = encode;
exports.decode = decode;
const compact_base64_1 = __importDefault(require("compact-base64"));
function encode(props) {
    return compact_base64_1.default.encode(JSON.stringify(props));
}
function decode(encoded) {
    return JSON.parse(compact_base64_1.default.decode(encoded));
}
